export const headerName = {
  add: "Добавить страну",
  edit: "Редактировать страну",
};
export const countriesData = {
  countryFullname: {
    key: "countryFullname",
    label: "Полное наименование (рус.)",
    type: "text",
    required: true,
    upperCase: true,
    pattern: {
      value: /^[А-Яа-я]+(?:\s[А-Яа-я]+)*$/,
      message: `Заполнение на русском языке`,
    },
  },
  countryName: {
    key: "countryName",
    label: "Краткое наименование (рус.)",
    type: "text",
    required: true,
    upperCase: true,
    pattern: {
      value: /^[А-Яа-я]+(?:\s[А-Яа-я]+)*$/,
      message: `Заполнение на русском языке`,
    },
  },
  countryFullnameEn: {
    key: "countryFullnameEn",
    label: "Полное наименование (англ.)",
    type: "text",
    required: true,
    upperCase: true,
    pattern: {
      value: /^[A-Za-z]+(?:\s[A-Za-z]+)*$/,
      message: `Заполнение на английском языке`,
    },
  },
  countryNameEn: {
    key: "countryNameEn",
    label: "Краткое наименование (англ.)",
    type: "text",
    required: true,
    upperCase: true,
    pattern: {
      value: /^[A-Za-z]+(?:\s[A-Za-z]+)*$/,
      message: `Заполнение на английском языке`,
    },
  },
  countryCode: {
    key: "countryCode",
    label: "Код",
    type: "text",
    required: true,
    upperCase: true,
    pattern: {
      value: /^[A-Z]{2}$/,
      message: `Введите 2 заглавные латинские буквы`,
    },
  },
};
